/* Catálogo Linktree – Don Kroketon (v2). Vanilla JS, sin dependencias.
   Responsabilidades: agrupar tarjetas (marca > especie > categoría siempre visible > subgrupo,
   colapsable solo en categorías extensas), cargar páginas adicionales vía Section Rendering API,
   buscador que abre los subgrupos con coincidencias, botones de categorías, navegación por marca (#marca-xxx)
   y "hoy" en la zona horaria de la tienda. */
(function () {
  'use strict';
  var root = document.getElementById('ct-root');
  if (!root) return;
  var pool = document.getElementById('ct-pool');
  var home = root.querySelector('[data-ct-view="home"]');
  var search = document.getElementById('ct-search');
  var clearBtn = root.querySelector('[data-ct-clear]');
  var backBtn = root.querySelector('.ct-bar__back');
  var emptyMsg = root.querySelector('[data-ct-empty]');
  var loadingMsg = root.querySelector('[data-ct-loading]');
  var toTop = root.querySelector('[data-ct-top]');

  var OPEN_MAX = parseInt(root.getAttribute('data-open-max'), 10); if (isNaN(OPEN_MAX)) OPEN_MAX = 6;
  var QUICKNAV_MIN = parseInt(root.getAttribute('data-quicknav-min'), 10); if (isNaN(QUICKNAV_MIN)) QUICKNAV_MIN = 12;

  var GROUPS = {
    1: { dog: 'Cachorro', cat: 'Gatito', nav: 'Cachorro', navCat: 'Gatito' },
    2: { dog: 'Adulto', cat: 'Adulto', nav: 'Adulto' },
    3: { dog: 'Senior', cat: 'Senior', nav: 'Senior' },
    4: { dog: 'Proteínas y variedades', cat: 'Proteínas y variedades', nav: 'Proteínas' },
    5: { dog: 'Alimento húmedo', cat: 'Alimento húmedo', nav: 'Húmedo' },
    6: { dog: 'Dietas y control de peso', cat: 'Control de peso', nav: 'Dietas' },
    7: { dog: 'Prescripción y dietas veterinarias', cat: 'Prescripción y dietas veterinarias', nav: 'Veterinario' },
    8: { dog: 'Razas específicas', cat: 'Razas específicas', nav: 'Razas' },
    9: { dog: 'Suplementos y otros', cat: 'Suplementos y otros', nav: 'Otros' }
  };
  var SPECIES = { perro: 'Perros', gato: 'Gatos', '': '' };
  var SPECIES_ORDER = { perro: 0, gato: 1, '': 2 };

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function groupLabel(g, species) {
    var def = GROUPS[g] || GROUPS[9];
    return species === 'gato' ? def.cat : def.dog;
  }
  function navLabel(g, species) {
    var def = GROUPS[g] || GROUPS[9];
    return (species === 'gato' && def.navCat) ? def.navCat : def.nav;
  }

  /* ---------- "Hoy" en la zona horaria configurada ---------- */
  function todayInfo() {
    var tz = root.getAttribute('data-tz') || 'America/Mexico_City';
    var fallback = { day: parseInt(root.getAttribute('data-today'), 10) || 1, ymd: parseInt(root.getAttribute('data-ymd'), 10) || 0 };
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (p) { map[p.type] = p.value; });
      var days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
      var day = days[map.weekday];
      var ymd = parseInt(map.year + map.month + map.day, 10);
      if (day && ymd) return { day: day, ymd: ymd };
    } catch (e) { /* navegador sin Intl.timeZone: usa el valor calculado por Liquid */ }
    return fallback;
  }
  function applyToday() {
    var t = todayInfo();
    root.className = root.className.replace(/\bct-today-\d\b/g, '').trim() + ' ct-today-' + t.day;
    /* Los precios "Hoy" se calculan al renderizar la página (Liquid, zona de la tienda). Si la página quedó abierta
       o en caché de un día anterior (fecha en America/Mexico_City distinta a la renderizada), se recarga UNA vez. */
    var renderedYmd = parseInt(root.getAttribute('data-ymd'), 10) || 0;
    if (renderedYmd && t.ymd && t.ymd !== renderedYmd) {
      var key = 'ctReload-' + t.ymd;
      try { if (window.sessionStorage.getItem(key)) return; window.sessionStorage.setItem(key, '1'); } catch (e) { /* sin sessionStorage: se recarga igual */ }
      var url = new URL(window.location.href);
      url.searchParams.set('dk', String(t.ymd) + '-' + Date.now());
      window.location.replace(url.toString());
    }
  }

  /* ---------- Agrupación en acordeones ---------- */
  function orderKey(species, group) { return (SPECIES_ORDER[species] === undefined ? 2 : SPECIES_ORDER[species]) * 100 + parseInt(group, 10); }

  function insertByOrder(container, el, key) {
    var children = container.children;
    for (var i = 0; i < children.length; i++) {
      var k = parseInt(children[i].getAttribute('data-order'), 10);
      if (k > key) { container.insertBefore(el, children[i]); return; }
    }
    container.appendChild(el);
  }

  function ensureGroup(brandSection, species, group) {
    var body = brandSection.querySelector('.ct-brand__body');
    var gid = 'g-' + species + '-' + group;
    var grp = body.querySelector('[data-gid="' + gid + '"]');
    if (grp) return grp;
    var spKey = orderKey(species, 0);
    if (SPECIES[species] && !body.querySelector('[data-sid="s-' + species + '"]')) {
      var h = document.createElement('h3');
      h.className = 'ct-species';
      h.setAttribute('data-sid', 's-' + species);
      h.setAttribute('data-order', spKey);
      h.textContent = SPECIES[species];
      insertByOrder(body, h, spKey);
    }
    grp = document.createElement('details');
    grp.className = 'ct-group' + (String(group) === '8' ? ' ct-group--breeds' : '');
    grp.setAttribute('data-gid', gid);
    grp.setAttribute('data-species', species);
    grp.setAttribute('data-group', group);
    grp.setAttribute('data-order', orderKey(species, group));
    grp.id = 'grp-' + brandSection.getAttribute('data-brand') + '-' + (species || 'x') + '-' + group;
    var sum = document.createElement('summary');
    sum.className = 'ct-group__title';
    sum.innerHTML = '<span class="ct-group__name">' + groupLabel(group, species) + '</span><span class="ct-group__count" aria-label="productos"></span><span class="ct-group__chev" aria-hidden="true"></span>';
    var body2 = document.createElement('div');
    body2.className = 'ct-group__body';
    grp.appendChild(sum);
    grp.appendChild(body2);
    insertByOrder(body, grp, orderKey(species, group));
    return grp;
  }

  /* Subgrupo dentro de un grupo (talla, proteína, función veterinaria, raza) */
  function ensureSub(grp, subOrder, subLabel) {
    var body = grp.querySelector('.ct-group__body');
    var key = subOrder + '|' + norm(subLabel);
    var sub = null;
    var kids = body.children;
    for (var i = 0; i < kids.length; i++) { if (kids[i].getAttribute('data-sub-key') === key) { sub = kids[i]; break; } }
    if (sub) return sub;
    sub = document.createElement('div');
    sub.className = 'ct-sub';
    sub.setAttribute('data-sub-key', key);
    sub.setAttribute('data-sub-order', subOrder);
    sub.setAttribute('data-sub-label', subLabel);
    var lbl = document.createElement('h5');
    lbl.className = 'ct-sub__title';
    lbl.textContent = subLabel;
    if (!subLabel) lbl.hidden = true;
    var list = document.createElement('div');
    list.className = 'ct-sub__list';
    sub.appendChild(lbl);
    sub.appendChild(list);
    /* orden: por número de subgrupo, luego alfabético por etiqueta (razas) */
    var sortKey = function (el) { return (parseInt(el.getAttribute('data-sub-order'), 10) || 0) * 1000; };
    var inserted = false;
    for (var j = 0; j < kids.length; j++) {
      var k = kids[j];
      var a = sortKey(k), b = sortKey(sub);
      if (a > b || (a === b && norm(k.getAttribute('data-sub-label')) > norm(subLabel))) { body.insertBefore(sub, k); inserted = true; break; }
    }
    if (!inserted) body.appendChild(sub);
    return sub;
  }

  function cardSortKey(card) {
    var o2 = ('00' + (card.getAttribute('data-order2') || '20')).slice(-3);
    return o2 + '|' + norm(card.getAttribute('data-title'));
  }

  function placeCard(card) {
    var brand = root.querySelector('.ct-brand[data-brand="' + card.getAttribute('data-brand') + '"]');
    if (!brand) { card.remove(); return; }
    var grp = ensureGroup(brand, card.getAttribute('data-species') || '', card.getAttribute('data-group') || '9');
    var sub = ensureSub(grp, parseInt(card.getAttribute('data-sub'), 10) || 0, card.getAttribute('data-sub-label') || '');
    var list = sub.querySelector('.ct-sub__list');
    var key = cardSortKey(card);
    var kids = list.children;
    for (var i = 0; i < kids.length; i++) {
      if (cardSortKey(kids[i]) > key) { list.insertBefore(card, kids[i]); return; }
    }
    list.appendChild(card);
  }

  function placeAll(container) {
    var cards = Array.prototype.slice.call(container.querySelectorAll('.ct-product'));
    cards.forEach(placeCard);
    return cards.length;
  }

  /* Segundo nivel colapsable: convierte un subgrupo (raza, función veterinaria, talla, proteína) en <details> */
  function collapsibleSub(s, breed) {
    if (s.tagName === 'DETAILS') return s;
    var c = s.querySelectorAll('.ct-product').length;
    var d = document.createElement('details');
    d.className = 'ct-sub ct-sub--acc' + (breed ? ' ct-sub--breed' : '');
    d.setAttribute('data-sub-key', s.getAttribute('data-sub-key'));
    d.setAttribute('data-sub-order', s.getAttribute('data-sub-order'));
    d.setAttribute('data-sub-label', s.getAttribute('data-sub-label'));
    var sm = document.createElement('summary');
    sm.className = 'ct-sub__title ct-sub__title--acc';
    sm.innerHTML = '<span>' + s.getAttribute('data-sub-label') + '</span><span class="ct-group__count">(' + c + ')</span><span class="ct-group__chev" aria-hidden="true"></span>';
    d.appendChild(sm);
    d.appendChild(s.querySelector('.ct-sub__list'));
    s.parentNode.replaceChild(d, s);
    return d;
  }

  /* Cierre de la agrupación: contadores, segundo nivel colapsable, estado inicial y botones de categorías.
     Las categorías principales (Cachorro, Adulto, Senior, Proteínas, Húmedo, Dietas, Veterinario, Razas)
     siempre se muestran abiertas; solo dentro de una categoría extensa (> OPEN_MAX productos y varios
     subgrupos con etiqueta) los subgrupos se vuelven colapsables. Nada se esconde en scroll lateral. */
  function finalizeBrand(b) {
    var total = b.querySelectorAll('.ct-product').length;
    b.setAttribute('data-total', total);
    b.querySelectorAll('.ct-group').forEach(function (g) {
      var n = g.querySelectorAll('.ct-product').length;
      g.querySelector('.ct-group__count').textContent = '(' + n + ')';
      g.setAttribute('data-count', n);
      var gnum = g.getAttribute('data-group');
      var subs = g.querySelectorAll('.ct-sub');
      var labeled = Array.prototype.filter.call(subs, function (s) { return !!s.getAttribute('data-sub-label'); });
      /* Subetiquetas solo cuando hay más de un subgrupo o la etiqueta aporta (razas/veterinario) */
      if (subs.length <= 1 && gnum !== '8' && gnum !== '7') {
        subs.forEach(function (s) { var t = s.querySelector('.ct-sub__title'); if (t) t.hidden = true; });
      }
      var extensive = n > OPEN_MAX && labeled.length > 1;
      if (extensive) labeled.forEach(function (s) { collapsibleSub(s, gnum === '8'); });
      g.open = true;
    });
    /* Botones de categorías (rejilla que salta de línea; nunca scroll lateral) */
    var nav = b.querySelector('.ct-quicknav');
    if (nav) nav.remove();
    if (total >= QUICKNAV_MIN) {
      nav = document.createElement('nav');
      nav.className = 'ct-quicknav';
      nav.setAttribute('aria-label', 'Categorías');
      var multi = b.querySelectorAll('.ct-species').length > 1;
      b.querySelectorAll('.ct-group').forEach(function (g) {
        var sp = g.getAttribute('data-species');
        var a = document.createElement('a');
        a.className = 'ct-quicknav__item';
        a.href = '#' + g.id;
        a.textContent = (multi && SPECIES[sp] ? (sp === 'gato' ? 'Gato' : 'Perro') + ' · ' : '') + navLabel(g.getAttribute('data-group'), sp);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          g.open = true;
          g.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        nav.appendChild(a);
      });
      b.querySelector('.ct-brand__head').insertAdjacentElement('afterend', nav);
    }
  }

  /* ---------- Páginas adicionales (colecciones > 250 productos) ---------- */
  var pages = parseInt(root.getAttribute('data-pages'), 10) || 1;
  var sectionId = root.getAttribute('data-section-id');
  var pending = 0;
  function loadPage(n) {
    pending++;
    if (loadingMsg) loadingMsg.hidden = false;
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + n;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var extraPool = doc.getElementById('ct-pool');
      if (extraPool) placeAll(extraPool);
    }).catch(function () { /* si falla, el catálogo sigue funcionando con lo cargado */ })
      .then(function () {
        pending--;
        if (pending === 0) { if (loadingMsg) loadingMsg.hidden = true; pruneEmptyBrands(); brands.forEach(finalizeBrand); if (search.value) runSearch(); }
      });
  }

  /* Marcas sin productos visibles (p. ej. vendor con productos en borrador): se ocultan botón y sección */
  function pruneEmptyBrands() {
    brands.forEach(function (b) {
      if (b.querySelector('.ct-product')) return;
      var key = b.getAttribute('data-brand');
      root.querySelectorAll('.ct-brand-btn[data-brand="' + key + '"]').forEach(function (btn) { btn.remove(); });
      b.remove();
    });
    brands = Array.prototype.slice.call(root.querySelectorAll('.ct-brand'));
    if (!search.value.trim()) route();
  }

  /* ---------- Vistas ---------- */
  var brands = Array.prototype.slice.call(root.querySelectorAll('.ct-brand'));
  function restoreOpenState() {
    root.querySelectorAll('.ct-group').forEach(function (g) { g.open = true; });
    root.querySelectorAll('.ct-sub--acc').forEach(function (d) { d.open = false; });
  }
  function showHome() {
    root.classList.remove('is-searching');
    brands.forEach(function (b) { b.hidden = true; });
    home.hidden = false;
    backBtn.hidden = true;
    emptyMsg.hidden = true;
  }
  function showBrand(key) {
    var target = null;
    brands.forEach(function (b) { var match = b.getAttribute('data-brand') === key; b.hidden = !match; if (match) target = b; });
    if (!target) { showHome(); return false; }
    root.classList.remove('is-searching');
    home.hidden = true;
    backBtn.hidden = false;
    emptyMsg.hidden = true;
    window.scrollTo({ top: 0, behavior: 'auto' });
    return true;
  }
  function route() {
    if (search.value.trim()) { runSearch(); return; }
    var m = /^#marca-([a-z0-9]+)$/i.exec(window.location.hash || '');
    if (m) { showBrand(m[1].toLowerCase()); } else { showHome(); }
  }
  window.addEventListener('hashchange', route);
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ct-home]');
    if (a) {
      e.preventDefault();
      if (search.value) { search.value = ''; clearBtn.hidden = true; clearSearchState(); }
      if (window.location.hash) { history.pushState('', document.title, window.location.pathname + window.location.search); }
      showHome();
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  });

  /* ---------- Búsqueda: abre los acordeones con coincidencias ---------- */
  var searchTimer = null;
  function runSearch() {
    var q = norm(search.value).trim();
    clearBtn.hidden = !q;
    if (!q) { route(); return; }
    var terms = q.split(/\s+/).filter(Boolean);
    root.classList.add('is-searching');
    home.hidden = true;
    backBtn.hidden = false;
    var total = 0;
    brands.forEach(function (b) {
      var count = 0;
      b.querySelectorAll('.ct-group').forEach(function (g) {
        var gc = 0;
        g.querySelectorAll('.ct-sub').forEach(function (s) {
          var sc = 0;
          s.querySelectorAll('.ct-product').forEach(function (card) {
            var hay = norm(card.getAttribute('data-search'));
            var ok = terms.every(function (t) { return hay.indexOf(t) !== -1; });
            card.classList.toggle('is-hidden', !ok);
            if (ok) sc++;
          });
          s.classList.toggle('is-empty', sc === 0);
          if (s.tagName === 'DETAILS' && sc > 0) s.open = true;
          gc += sc;
        });
        g.classList.toggle('is-empty', gc === 0);
        if (gc > 0) g.open = true;
        count += gc;
      });
      b.querySelectorAll('.ct-species').forEach(function (h) {
        var sp = h.getAttribute('data-sid').replace('s-', '');
        var any = Array.prototype.some.call(b.querySelectorAll('.ct-group[data-species="' + sp + '"]'), function (g) { return !g.classList.contains('is-empty'); });
        h.classList.toggle('is-empty', !any);
      });
      b.classList.toggle('is-empty', count === 0);
      b.hidden = false;
      total += count;
    });
    emptyMsg.hidden = total !== 0 || pending > 0;
  }
  function clearSearchState() {
    root.querySelectorAll('.is-hidden, .is-empty').forEach(function (el) { el.classList.remove('is-hidden', 'is-empty'); });
    restoreOpenState();
  }
  search.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      if (!search.value.trim()) { clearBtn.hidden = true; clearSearchState(); route(); return; }
      runSearch();
    }, 120);
  });
  search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); search.blur(); } });
  clearBtn.addEventListener('click', function () { search.value = ''; clearSearchState(); route(); search.focus(); });

  /* ---------- Volver arriba ---------- */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { toTop.hidden = window.scrollY < 600; ticking = false; });
  }, { passive: true });
  toTop.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------- Init ---------- */
  applyToday();
  setInterval(applyToday, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) applyToday(); });
  placeAll(pool);
  for (var p = 2; p <= pages; p++) loadPage(p);
  if (pages <= 1) { pruneEmptyBrands(); }
  brands.forEach(finalizeBrand);
  route();
})();